import { useState } from 'react';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../shared/state/root-reducer';
import { AppDispatch } from '../shared/state/store';
import {
  showErrorStatus,
  showStatus,
} from '@finpay-development/shared-platform/lib/esm/security/state/user-slice';
import { triggerCallPatient } from './call-patient-service';
import { useShouldShowCallPatientButton } from './use-should-show-call-patient-button';

const buttonSx = {
  backgroundColor: '#297ec1',
  color: 'white',
  fontSize: '1.6rem',
  fontWeight: 600,
  textTransform: 'none' as const,
  fontFamily: 'Inter, "Helvetica Neue", sans-serif',
  '&:hover': {
    backgroundColor: '#1f5f9a',
  },
};

export const CallPatientButton = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isLoading, setIsLoading] = useState(false);
  const show = useShouldShowCallPatientButton();

  const selectedEncounter = useSelector(
    (state: RootState) => state.patientContext?.selectedEncounter
  );
  const selectedPatient = useSelector(
    (state: RootState) => state.patientContext?.selectedPatient
  );
  const payersMap = useSelector(
    (state: RootState) => state.adminContext?.adminConfigurationContext?.payersMap
  );

  if (!show) {
    return null;
  }

  const handleClick = async () => {
    if (!selectedEncounter?.patientEncounterId) {
      dispatch(showErrorStatus('Lookup patient first'));
      return;
    }
    setIsLoading(true);
    try {
      const result = await triggerCallPatient(
        selectedEncounter,
        selectedPatient,
        payersMap
      );
      if (result.ok) {
        dispatch(showStatus('Call Patient request accepted'));
      } else {
        dispatch(showErrorStatus(result.errorMessage || 'Call Patient failed'));
      }
    } catch (err: any) {
      dispatch(showErrorStatus(err?.message || 'Call Patient failed'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={handleClick}
      disabled={isLoading}
      test-id="call-patient-button"
      sx={{ ...buttonSx, mr: '0.8rem' }}
    >
      {isLoading ? 'Calling…' : 'Call Patient'}
    </Button>
  );
};
